<template>
<div class="chapter">
<div class="inner_page">
<p><span id="qContents4"></span></p>
<p class="chapter-name"><span class="bold">Contents</span></p>
<p class="body_ni"><a href="#/Text/preface1938"><span>Preface to the 1938 Edition</span></a></p>
<p class="body_ni"><a href="#/Text/foreword1997"><span>Foreword to the 1997 Edition by Wilebaldo Solano</span></a></p>
<p class="body_ni"><a href="#/Text/transintro"><span>Translator’s Introduction by Peter Sedgwick</span></a></p>
<p class="body_ni"><a href="#/Text/transackn"><span>Translator’s Acknowledgements</span></a></p>
<p class="body_ni"><a href="#/Text/preface1930"><span>Preface to the 1930 Edition</span></a></p>
<p class="body_ni"> </p>
<p class="body_ni"><a href="#/Text/chapter1"><span>1 From Serfdom to Proletarian Revolution</span></a></p>
<p class="body_ni"><span href="#/Text/chapter2" title="Link target outside of Sample"><span>2 The Insurrection of 25 October 1917</span></span></p>
<p class="body_ni"><span href="#/Text/chapter3" title="Link target outside of Sample"><span>3 The Urban Middle Classes against the Proletariat</span></span></p>
<p class="body_ni"><span href="#/Text/chapter4" title="Link target outside of Sample"><span>4 The First Flames of the Civil War: The Constituent Assembly</span></span></p>
<p class="body_ni"><span href="#/Text/chapter5" title="Link target outside of Sample"><span>5 Brest-Litovsk</span></span></p>
<p class="body_ni"><span href="#/Text/chapter6" title="Link target outside of Sample"><span>6 The Truce and the Great Retrenchment</span></span></p>
<p class="body_ni"><span href="#/Text/chapter7" title="Link target outside of Sample"><span>7 The Famine and the Czechoslovak Intervention</span></span></p>
<p class="body_ni"><span href="#/Text/chapter8" title="Link target outside of Sample"><span>8 The July-August Crisis</span></span></p>
<p class="body_ni"><span href="#/Text/chapter9" title="Link target outside of Sample"><span>9 The Terror and the Will to Victory</span></span></p>
<p class="body_ni"><span href="#/Text/chapter10" title="Link target outside of Sample"><span>10 The German Revolution</span></span></p>
<p class="body_ni"><span href="#/Text/chapter11" title="Link target outside of Sample"><span>11 War Communism</span></span></p>
<p class="body_ni"> </p>
<p class="body_ni"><span href="#/Text/notes" title="Link target outside of Sample"><span>Notes</span></span></p>
<p class="body_ni"><span href="#/Text/postface" title="Link target outside of Sample"><span>Postface: Thirty Years After the Russian Revolution</span></span></p>
<p class="body_ni"><span href="#/Text/postscript" title="Link target outside of Sample"><span>Postscript: The Allied Part in the Czechoslovak Intervention</span></span></p>
<p class="body_ni"><span href="#/Text/postscriptnotes" title="Link target outside of Sample"><span>Notes 497 Index</span></span></p>
<p class="body_ni"><span href="#/Text/more" title="Link target outside of Sample"><span>More by Victor Serge Available in English</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?53c0f206